import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import i18n from 'i18n'

import { tags } from 'redux/tags'

export const baseApi = createApi({
  reducerPath: 'API',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BASE_URL}`,
    prepareHeaders: (headers) => {
      const token = window.localStorage.getItem('token')
      if (token) headers.set('authorization', `Token ${token}`)
      headers.set('Accept', 'application/json')
      headers.set('Accept-Language', i18n.language)

      return headers
    },
  }),
  tagTypes: tags,
  endpoints: () => ({}),
})
